define('Tavano.TTVatTaxes.VATTaxes.View', [
	'tavano_ttvattaxes_vattaxes.tpl',
	'Backbone'
], function (
	tavano_ttvattaxes_vattaxes_tpl,
	Backbone
) {
	'use strict';

	// @class Tavano.TTVatTaxes.VATTaxes.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavano_ttvattaxes_vattaxes_tpl,

		initialize: function (options) {
			this.container = options.container;
		},

		events: {
			'click [data-action="toggleIcon"]': 'toggleIcon'
		},

		toggleIcon: function toggleIcon(e) {
			e.preventDefault();
			e.currentTarget.classList.toggle('active');
			var toggle = e.currentTarget.classList.contains('active');
			this.trigger('vatTaxes:change', { toggle: toggle});
		},

		getContext: function getContext() {
			this.message = this.message || 'Hello World!!';
			return {
				message: this.message
			};
		}
	});
});
